import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { DecorativeDivider, OmMark, CornerOrnament } from "@/components/Ornaments";

const GALLERY = {
  temple: [
    "https://images.unsplash.com/photo-1570605505301-0f713202ca7a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.pexels.com/photos/36536562/pexels-photo-36536562.jpeg",
    "https://images.pexels.com/photos/5593067/pexels-photo-5593067.jpeg",
  ],
  rituals: [
    "https://images.unsplash.com/photo-1551979122-3a33d9391335?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.unsplash.com/photo-1630764883473-e8c2056f0589?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.pexels.com/photos/8819252/pexels-photo-8819252.jpeg",
  ],
  ceremonies: [
    "https://images.pexels.com/photos/18723429/pexels-photo-18723429.jpeg",
    "https://images.pexels.com/photos/8819252/pexels-photo-8819252.jpeg",
    "https://images.unsplash.com/photo-1551979122-3a33d9391335?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  ],
  surroundings: [
    "https://images.pexels.com/photos/5593067/pexels-photo-5593067.jpeg",
    "https://images.unsplash.com/photo-1570605505301-0f713202ca7a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    "https://images.pexels.com/photos/36536562/pexels-photo-36536562.jpeg",
  ],
};

export default function Gallery() {
  const { t } = useTranslation();
  const [tab, setTab] = useState("temple");
  return (
    <div data-testid="gallery-page">
      <section className="section-tight bg-paper-strong relative overflow-hidden">
        <CornerOrnament corner="tr" element="yantra" />
        <div className="container-x relative text-center">
          <OmMark size={42} className="mx-auto text-[color:var(--brand)] mb-4" />
          <DecorativeDivider label={t("nav.gallery")} className="mb-5" />
          <h1 className="font-heading text-5xl md:text-7xl tracking-display leading-[0.98]">
            Sacred <em className="italic-serif text-[color:var(--brand)]">Glimpses</em>
          </h1>
          <p className="mt-5 max-w-2xl mx-auto opacity-80">{t("gallery.subtitle")}</p>
        </div>
      </section>

      <section className="section bg-paper">
        <div className="container-x">
          <Tabs value={tab} onValueChange={setTab}>
            <TabsList className="flex flex-wrap justify-center bg-transparent gap-2 mb-12">
              {Object.keys(GALLERY).map((k) => (
                <TabsTrigger
                  key={k}
                  value={k}
                  data-testid={`gallery-tab-${k}`}
                  className="data-[state=active]:bg-[color:var(--brand)] data-[state=active]:text-[#faf8f5] data-[state=active]:shadow-none rounded-full px-5 py-2 text-sm border border-[color:var(--border-strong)] italic-serif"
                >
                  {t(`gallery.categories.${k}`)}
                </TabsTrigger>
              ))}
            </TabsList>
            {Object.entries(GALLERY).map(([k, imgs]) => (
              <TabsContent key={k} value={k}>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {imgs.map((src, i) => (
                    <div key={i} className="arch-mask aspect-[5/4] relative border border-[color:var(--border-strong)] bg-white p-2">
                      <div className="arch-mask w-full h-full">
                        <img src={src} alt={`${k}-${i}`} className="w-full h-full object-cover" />
                      </div>
                    </div>
                  ))}
                </div>
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </section>
    </div>
  );
}
